import {DataARClaimListModel} from './data-ar-claim-list';
import {InsurancePaymentOverpayListModel} from './insurance-payment-overpay-list.model';

export class SaveInsurancePaymentDistributionsModel {
  PaymentID: string;
  dataARClaims: DataARClaimListModel[];
  overPayList: InsurancePaymentOverpayListModel[];
  claimItemOverPayList: InsurancePaymentOverpayListModel[];
  PatientID: string;
  isClaimRefusal: boolean = false;
}
